import React from 'react';
import styled from 'styled-components';

import { ArrowUpRight } from '@icons/common';

interface HotelNameProps {
  hotelId?: number | string | null;
  name: string;
}

// Название отеля и иконка, открывающая страницу отеля на витрине агентства в новой вкладке
// (админка открыта на домене витрины). Своего шрифта у названия нет — оно выглядит как текст вокруг.
const HotelName: React.FC<HotelNameProps> = ({ hotelId, name }) => (
  <Wrapper>
    <span>{name}</span>
    {hotelId ? (
      <HotelPageLink
        aria-label={`Открыть страницу отеля ${name}`}
        href={`${window.location.origin}/hotels/${hotelId}`}
        rel="noopener noreferrer"
        target="_blank"
        title="Открыть страницу отеля"
      >
        <ArrowUpRight />
      </HotelPageLink>
    ) : null}
  </Wrapper>
);

// Название и иконка выровнены по центру друг друга по вертикали.
const Wrapper = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 4px;
  max-width: 100%;
`;

const HotelPageLink = styled.a`
  align-items: center;
  border-radius: 4px;
  color: #007aff;
  display: inline-flex;
  flex-shrink: 0;
  height: 18px;
  justify-content: center;
  width: 18px;

  &:hover {
    background: #eef5ff;
  }

  svg {
    height: 8px;
    width: 9px;
  }

  path {
    stroke: currentColor;
  }
`;

export default HotelName;
